import { has } from 'lodash/object';
import moment from 'moment';

import { i18nt } from '../root';

export function getPatientName(patient) {
  return has(patient, 'name') ? patient.name : '---';
}

export function getPatientFullName(patientInfo) {
  let fullName = '';

  const firstName = patientInfo?.firstName || patientInfo?.patientFirstName,
    middleName = patientInfo?.middleName || patientInfo?.patientMiddleName,
    lastName = patientInfo?.lastName || patientInfo?.patientLastName;

  if (firstName) {
    fullName += firstName;
  }
  if (middleName) {
    fullName += ' ' + middleName;
  }
  if (lastName) {
    fullName += ' ' + lastName;
  }
  return fullName;
}

export function getPatientPreferredName(patientInfo) {
  const preferredName = patientInfo?.preferredName || patientInfo?.patientPreferredName;
  if (preferredName) {
    return ' (' + preferredName + ')';
  }
  return '';
}

export function getPatientAgeFromDob(patientInfo) {
  const age = patientInfo && patientInfo.dob ? moment().diff(patientInfo.dob, 'years') : '';
  const yearLabel = age > 1 ? 'years' : 'year';
  return age && age > 0 ? `${age} ${i18nt(yearLabel)}` : `0 ${i18nt('year')}`;
}

export function getPatientAge(patient) {
  if (has(patient, 'age')) {
    const { age } = patient;
    return `${age} ${age === 1 ? 'year' : 'years'}`;
  }
}

export function getPatientDob(patient) {
  return has(patient, 'dob') && patient.dob;
}
